import * as TYPES from './type';

//签到
import signMutations from './sign/mutations'
//表现
import showMutations from './show/mutations'
//讨论
import discussMutations from './discuss/mutations'
//问卷
import quesMutations from './ques/mutations'
//互评
import mutualEvaluateMutations from './mutualEvaluate/mutations'
//测试
import testMutations from './test/mutations'
export default {
  //课中活动
  [TYPES.ACTIVITY_LIST_INFO](state, { result, type }) {
    state.activityQuery[type] = result.result
  },
  ...signMutations, //签到
  ...showMutations, //表现
  ...discussMutations, //讨论
  ...quesMutations, //问卷
  ...mutualEvaluateMutations, //互评
  ...testMutations, //测验
}


// WEBPACK FOOTER //
// ./src/store/kzActivity/mutations.js